module.exports = __webpack_public_path__ + "media/images/btn_pay_now-67a4ddf9c71c82ce9092421053f809be.gif";